import React from 'react';

function About() {
    return (
        <>
            <h2>Company Information</h2>
            <p>
                We are Y.O.U Clothing, a brand focused on providing everyday-use clothing
                that is stylish, comfortable, and affordable.
            </p>

            <h2>Owner Profile</h2>
            <p><strong>Owner:</strong> Gabriel James T. Alpasan</p>
            <p><strong>Course:</strong> BSIT WMA</p>
        </>
    );
}

export default About;
